module.exports = __webpack_public_path__ + "img/scotland.d9d94adf.svg";